export const NOTIFICATION_SEND = 'NOTIFICATION_SEND';
export const NOTIF_CLEAR = 'NOTIF_CLEAR';



// WEBPACK FOOTER //
// ./src/constants/notifications.js